module.exports = __webpack_public_path__ + "img/como-criar-estrutura-widget-grafico.996ba47a.jpg";